import React from 'react'
import { useHelpscoutChat } from 'lib/useHelpscoutChat'

/**
 * Reusable component for opening Helpscout Beacon chat
 * Can be used anywhere in the app to trigger the chat widget
 * 
 * @param {string} children - The text/content to display (default: 'Chat with Us')
 * @param {string} className - CSS classes to apply
 * @param {string} ariaLabel - Custom aria-label for screen readers (default: 'Open chat support')
 * @param {object} props - Additional props to pass to the anchor element
 */
export default function HelpscoutChatLink({ 
  children = 'Chat with Us', 
  className = 'text-blue-700 hover:underline',
  'aria-label': ariaLabel,
  ...props 
}) {
  const { openChat } = useHelpscoutChat()

  const handleClick = (e) => {
    e.preventDefault()
    openChat()
  }

  const handleKeyDown = (e) => {
    // Support Enter and Space keys for keyboard navigation
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      openChat()
    }
  }

  return (
    <a 
      href="#"
      role="button"
      tabIndex={0}
      aria-label={ariaLabel || 'Open chat support'}
      data-helpscout-chat-link
      className={className}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      {...props}
    >
      {children}
    </a>
  )
}

